export default __webpack_public_path__ + "static/media/articles-main-lg.9fe2bff0.jpg";